// Shared type definitions and helpers for all scene-based compositions

export interface WordTiming {
  text: string;
  startMs: number;
  endMs: number;
}

export interface KenBurnsConfig {
  startScale: number;
  endScale: number;
  startX: number;
  endX: number;
  startY: number;
  endY: number;
  startRotation?: number;
  endRotation?: number;
}

export interface Scene {
  id: number;
  name: string;
  startMs: number;
  endMs: number;
  words: WordTiming[];
  primaryColor: string;
  accentColor: string;
  backgroundImage: string;
  kenBurns: KenBurnsConfig;
}

export interface LogoSceneConfig {
  startMs: number;
  endMs: number;
  primaryColor: string;
  accentColor: string;
}

// Ken Burns presets for visual variety - enhanced for more dramatic movement
export const KEN_BURNS_PRESETS = {
  zoomIn: {
    startScale: 1.0,
    endScale: 1.2,
    startX: 50,
    endX: 50,
    startY: 50,
    endY: 48,
    startRotation: 0,
    endRotation: 0,
  },
  zoomOut: {
    startScale: 1.2,
    endScale: 1.0,
    startX: 48,
    endX: 52,
    startY: 48,
    endY: 50,
    startRotation: 0,
    endRotation: 0,
  },
  panRight: {
    startScale: 1.18,
    endScale: 1.32,
    startX: 34,
    endX: 66,
    startY: 54,
    endY: 46,
    startRotation: 0,
    endRotation: 1.2,
  },
  panLeft: {
    startScale: 1.32,
    endScale: 1.18,
    startX: 66,
    endX: 34,
    startY: 46,
    endY: 54,
    startRotation: 1.2,
    endRotation: 0,
  },
  zoomInLower: {
    startScale: 1.08,
    endScale: 1.38,
    startX: 52,
    endX: 44,
    startY: 34,
    endY: 66,
    startRotation: 0,
    endRotation: 0,
  },
  dramaticZoom: {
    startScale: 1.05,
    endScale: 1.45,
    startX: 56,
    endX: 42,
    startY: 58,
    endY: 38,
    startRotation: 0,
    endRotation: -1.2,
  },
  zoomWithTilt: {
    startScale: 1.08,
    endScale: 1.32,
    startX: 46,
    endX: 58,
    startY: 54,
    endY: 42,
    startRotation: 0,
    endRotation: 2.4,
  },
} as const;

// Helper to convert ms to frames at 30fps
export function msToFrames(ms: number, fps: number = 30): number {
  return Math.round((ms / 1000) * fps);
}

// Helper to get current scene based on frame
export function getCurrentScene(scenes: Scene[], frame: number, fps: number = 30): Scene | null {
  const currentMs = (frame / fps) * 1000;
  return scenes.find(scene => currentMs >= scene.startMs && currentMs < scene.endMs) || null;
}

// Helper to get words visible at current time
export function getVisibleWords(currentMs: number, scene: Scene): WordTiming[] {
  return scene.words.filter(word => currentMs >= word.startMs);
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
